import { render, staticRenderFns } from "./ChatbotRejectReasonModal.vue?vue&type=template&id=34195e1e&scoped=true"
import script from "./ChatbotRejectReasonModal.vue?vue&type=script&lang=js"
export * from "./ChatbotRejectReasonModal.vue?vue&type=script&lang=js"
import style0 from "./ChatbotRejectReasonModal.vue?vue&type=style&index=0&id=34195e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34195e1e",
  null
  
)

export default component.exports